import { action, computed, observable } from 'mobx'
import { task } from 'mobx-task'
import { type DocumentCreationModalViewModel } from '@/features/documents/DocumentCreationModal/DocumentCreationModalViewModel'
import { isNotNil } from '@/utils/object-util'

/**
 * Uploads the draft return so the client can review it.
 */
export class JobProgressionRequestDraftApprovalViewModel {
  @observable
  accessor documentViewModel: DocumentCreationModalViewModel | null = null

  constructor(
    private readonly _createDocumentCreationModalViewModel: () => DocumentCreationModalViewModel,
  ) {}

  @computed
  get canRequestDraftApproval(): boolean {
    const draftReturn = this.documentViewModel?.documentCreationItemVms.find(
      (i) => i.selectedType?.id === 'DRAFT_RETURN',
    )

    return isNotNil(draftReturn)
  }

  @action.bound
  show() {
    this.documentViewModel = this._createDocumentCreationModalViewModel()
    this.documentViewModel.modal.show()
  }

  @action.bound
  close() {
    this.documentViewModel?.clearFiles()
    this.documentViewModel?.modal.close()
  }

  requestDraftApproval = task.resolved(async () => {
    if (!this.documentViewModel) {
      return
    }

    await this.documentViewModel.uploadFiles()

    this.close()
  })
}
